import { useLang } from "../i18n";

const base = "w-full bg-white border border-[#101214]/15 rounded-xl px-4 py-3 text-sm text-[#101214] placeholder:text-[#A8ADB3] focus:outline-none focus:border-[#FF6600] focus:ring-2 focus:ring-[#FF6600]/20 transition";
const baseDark = "w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-sm text-white placeholder:text-white/35 focus:outline-none focus:border-[#FF6600] transition";

export const Field = ({ label, error, children, required, htmlFor }) => (
  <div>
    <label htmlFor={htmlFor} className="block text-xs font-bold tracking-wide uppercase text-[#101214]/70 mb-1.5">
      {label}{required && <span className="text-[#FF6600]"> *</span>}
    </label>
    {children}
    {error && <p className="mt-1 text-xs text-red-600" role="alert">{error}</p>}
  </div>
);

export const Input = ({ dark, ...props }) => <input {...props} className={dark ? baseDark : base} />;
export const Textarea = ({ dark, ...props }) => <textarea rows={4} {...props} className={dark ? baseDark : base} />;
export const Select = ({ dark, children, ...props }) => (
  <select {...props} className={`${dark ? baseDark : base} appearance-none`}>{children}</select>
);

export const Consent = ({ checked, onChange, error, testid = "form-consent" }) => {
  const { t } = useLang();
  return (
    <div>
      <label className="flex items-start gap-3 text-sm text-[#101214]/70 cursor-pointer">
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
          data-testid={testid} className="mt-0.5 w-4 h-4 accent-[#FF6600]" />
        <span>{t.forms.consentLabel}</span>
      </label>
      {error && <p className="mt-1 text-xs text-red-600" role="alert">{error}</p>}
    </div>
  );
};

export const Honeypot = ({ value, onChange }) => (
  <div className="hidden" aria-hidden="true">
    <input type="text" tabIndex={-1} autoComplete="off" value={value}
      onChange={(e) => onChange(e.target.value)} name="website_url" />
  </div>
);

export const SubmitButton = ({ busy, children, testid = "form-submit-button" }) => {
  const { t } = useLang();
  return (
    <button type="submit" disabled={busy} data-testid={testid}
      className="w-full sm:w-auto inline-flex justify-center items-center gap-2 bg-[#FF6600] hover:bg-[#FF9900] disabled:opacity-50 text-[#08090A] font-black rounded-full px-8 py-3.5 text-sm transition-colors shadow-[0_0_20px_rgba(255,102,0,0.3)]">
      {busy ? t.forms.sending : children}
    </button>
  );
};

export const FormStatus = ({ ok, msg, testid = "form-status" }) =>
  msg ? (
    <p role="status" data-testid={testid}
      className={`text-sm font-bold rounded-xl px-4 py-3 ${ok ? "bg-[#FF6600]/10 text-[#FF6600]" : "bg-red-50 text-red-600"}`}>
      {msg}
    </p>
  ) : null;
